import {Component, OnInit, ViewChild} from '@angular/core';
import {AvailableTagsComponent} from '../available-tags/available-tags.component';

// use this as a base class for list components that work with tags
// make sure to use the AvailableTagsComponent inside the template like so:
// <app-available-tags module="notes" (selection)="setTagSelection($event)"></app-available-tags>
export abstract class TaggedBaseComponent implements OnInit {
    @ViewChild(AvailableTagsComponent)
    protected availableTagsComponent: AvailableTagsComponent;
    selectedTags = [];
    moduleName;
    public filtered;
    constructor(moduleName: string) {
        this.moduleName = moduleName;
    }

    ngOnInit() {
    }

    toggleTag(obj) {
        const tag = obj.tag;
        if (obj.selected) {
            this.addTag(tag);
        } else {
            this.removeTag(tag);
        }
    }

    addTag(tag) {
        this.selectedTags = this.availableTagsComponent.selectedTags;
        if (this.selectedTags.indexOf(tag) === -1) {
            this.selectedTags.push(tag);
        }
        this.filter();
    }

    removeTag(tag) {
        this.selectedTags = this.availableTagsComponent.selectedTags;
        this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
        this.filter();
    }

    setTagSelection(selectedTags) {
        this.selectedTags = selectedTags;
        this.filter();
    }

    filter() {
        this.filtered = this[this.moduleName].filter((note) => {
            if (this.selectedTags.length === 0) {
                return true;
            }
            const intersection = note.tags.filter((tag) => {
                return -1 !== this.selectedTags.indexOf(tag);
            });
            return intersection.length > 0;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/tags/tagged-base/tagged-base.component.ts